<!-- Content area -->
<div
  class="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden bg-white dark:bg-slate-900"
>
  <!-- Supposed to be header -->
  <main class="grow">
    <div class="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div class="max-w-2xl m-auto mt-16">
        <div class="text-center px-4">
          <div class="inline-flex mb-8">
            <img
              class="dark:hidden"
              src="assets/images/unauthorized.svg"
              width="176"
              height="176"
              alt="404 illustration"
            />
            <img
              class="hidden dark:block"
              src="assets/images/unauthorized.svg"
              width="176"
              height="176"
              alt="404 illustration dark"
            />
          </div>
          <div class="mb-14">
            <h1 class="ord-h1">401 - Unauthorized</h1>
            <p class="ord-subtitle-1">
              Your account doesn't have access to this page.
            </p>
            <p class="ord-body-1">
              If you believe this is a mistake, please contact support.
            </p>
          </div>
          <app-button (btnClick)="onBackButtonClicked()">
            <ng-template appButtonText>Back To Home</ng-template>
          </app-button>
        </div>
      </div>
    </div>
  </main>
</div>
